
  (() => {
    const normalize = (value) => (value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const numberList = (value, unit) => {
      const patterns = unit === 'kwh' ? [/(\d+(?:[.,]\d+)?)\s*kwh/gi] : [/(\d+)\s*(?:x|×)\s*\d{3}\s*w/gi, /\d{3}\s*w\s*(?:x|×)\s*(\d+)/gi, /(\d+)\s*(?:solarmodule|module)/gi];
      const found = [];
      patterns.forEach((pattern) => {
        let match;
        while ((match = pattern.exec(value || '')) !== null) {
          const parsed = Number(String(match[1]).replace(',', '.'));
          if (Number.isFinite(parsed) && !found.includes(parsed)) found.push(parsed);
        }
      });
      return found.sort((a, b) => a - b);
    };
    const labelList = (values, unit, fallback) => {
      if (!values.length) return fallback;
      if (values.length <= 3) return `${values.map((value) => new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(value)).join(' / ')} ${unit}`;
      return `${new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(values[0])}–${new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(values.at(-1))} ${unit}`;
    };
    const solarmoduleQuantity = (value) => {
      const text = normalize(value);
      if (/\b(ohne|kein|keine|keinen|none)\b/.test(text) || text === '0' || /(?:^|:)\s*0(?:\b|$)/.test(text)) return 0;
      const patterns = [/(\d{1,2})\s*(?:x|×)\s*\d{3}\s*w\b/, /\d{3}\s*w\s*(?:x|×)\s*(\d{1,2})(?!\d)/, /(?:x|×)\s*(\d{1,2})(?!\d)/, /(\d{1,2})\s*(?:solar)?module?\b/, /(\d{1,2})\s*panels?\b/, /(?:anzahl|menge)\D{0,6}(\d{1,2})/];
      for (const pattern of patterns) {
        const match = text.match(pattern);
        if (match) return Number(match[1]);
      }
      return null;
    };
    const shippingDelivery = window.MPSmartShippingDelivery;
    const resolveDelivery = (variant, country, classifications) => {
      if (!shippingDelivery) return { status: 'unavailable', mode: '' };
      return shippingDelivery.resolve({
        variant,
        classification: shippingDelivery.classificationFor(variant, classifications),
        country,
      });
    };
    const deliveryText = (variant, country, classifications) => {
      if (!shippingDelivery) return 'Lieferzeit wird im Checkout berechnet';
      return shippingDelivery.text(resolveDelivery(variant, country, classifications), {
        available: Boolean(variant.available),
      });
    };
    const taxNoteText = (card) => {
      const taxSelector = document.querySelector('#mp-tax-selector');
      if (!taxSelector) return 'Preis gemäß aktueller Shop-Einstellung';
      const country = String(taxSelector.dataset.country || 'DE').toUpperCase();
      const role = taxSelector.querySelector('[data-mp-tax-role][aria-pressed="true"]')?.dataset.mpTaxRole || 'private';
      const mode = String(card.dataset.mpTaxMode || '');
      if (mode === 'de0_twin') {
        if (country === 'DE') return role === 'business' ? 'Bruttopreis inkl. 19 % MwSt.' : 'Preis mit 0 % MwSt.';
        return role === 'business'
          ? 'Voraussichtlicher Nettopreis · USt-IdNr. wird im Checkout geprüft'
          : `Voraussichtlicher Bruttopreis inkl. MwSt. in ${country} · endgültig im Checkout`;
      }
      if (mode === 'gross_inclusive_single') {
        if (country === 'DE') return 'Shopify-Preis inkl. 19 % MwSt.';
        return role === 'business'
          ? 'Voraussichtlicher Nettopreis · USt-IdNr. wird im Checkout geprüft'
          : `Shopify-Preis inkl. MwSt. in ${country} · endgültig im Checkout`;
      }
      return 'Preis gemäß aktueller Shop-Einstellung · Steuerberechnung im Checkout';
    };
    const updateTaxNote = (card) => {
      const note = card.querySelector('[data-card-price-note]');
      if (note) note.textContent = taxNoteText(card);
    };
    const ensureTaxVariant = async (card, variant) => {
      const mode = String(variant?.taxMode || '');
      if (!mode) return true;
      if (mode !== 'de0_twin' && mode !== 'gross_inclusive_single') return false;
      const ensureVariant = window.MiniPowerTax?.ensureVariant;
      if (typeof ensureVariant !== 'function') return false;
      try {
        return await ensureVariant(card, variant.id) === true;
      } catch (error) {
        return false;
      }
    };
    const connectTaxNotes = (root, records) => {
      const refresh = () => records.forEach((record) => { if (record.card) updateTaxNote(record.card); });
      refresh();
      const taxSelector = document.querySelector('#mp-tax-selector');
      if (!taxSelector) return;
      const observer = new MutationObserver(refresh);
      observer.observe(taxSelector, { attributes: true, subtree: true, attributeFilter: ['aria-pressed', 'data-country'] });
      root._mpTaxNoteObserver = observer;
    };
    const transition = (update) => {
      if (!document.startViewTransition) return update();
      try {
        const viewTransition = document.startViewTransition(update);
        viewTransition.finished.catch(() => {});
        return viewTransition;
      } catch (error) {
        return update();
      }
    };
    const hydrateDesktopHero = (root) => {
      const template = root.querySelector('template[data-desktop-hero]');
      if (!template) return;
      const media = window.matchMedia('(min-width: 761px)');
      const sync = () => {
        const instance = root.querySelector('[data-desktop-hero-instance]');
        if (!media.matches) {
          instance?.remove();
          return;
        }
        if (instance) return;
        const fragment = template.content.cloneNode(true);
        const element = fragment.firstElementChild;
        if (!element) return;
        element.dataset.desktopHeroInstance = '';
        template.after(fragment);
      };
      sync();
      media.addEventListener('change', sync);
      root._mpHeroMedia = media;
      root._mpHeroSync = sync;
    };
    const init = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      hydrateDesktopHero(root);
      const grid = root.querySelector('[data-grid]');
      const deferredCardTemplates = Array.from(root.querySelectorAll('template[data-card-template]'));
      const liveCards = Array.from(grid.querySelectorAll(':scope > [data-card]'));
      const createRecord = (source, card = null, template = null) => {
        const dataset = { ...source.dataset };
        const options = `${dataset.title || ''} ${dataset.options || ''}`;
        return {
          dataset,
          card,
          template,
          initialized: false,
          _capacity: numberList(options, 'kwh'),
          _modules: numberList(options, 'module').filter((value) => [2, 4, 6, 8, 10, 12, 16].includes(value))
        };
      };
      const records = [
        ...liveCards.map((card) => createRecord(card, card)),
        ...deferredCardTemplates.map((template) => createRecord(template, null, template))
      ];
      const recordByHandle = new Map(records.map((record) => [record.dataset.handle, record]));
      const filters = root.querySelector('[data-filters]');
      const backdrop = root.querySelector('[data-filter-backdrop]');
      const activeRow = root.querySelector('[data-active-filters]');
      const brandSelect = root.querySelector('[data-brand]');
      const moduleCountSelect = root.querySelector('[data-module-count]');
      const search = root.querySelector('[data-search]');
      const searchSubmit = root.querySelector('[data-search-submit]');
      const searchClear = root.querySelector('[data-search-clear]');
      const sort = root.querySelector('[data-sort]');
      const mount = root.querySelector('[data-mount]');
      const available = root.querySelector('[data-available]');
      const loadMore = root.querySelector('[data-load-more]');
      const nativePagination = root.querySelector('[data-native-pagination]');
      const catalogStatus = root.querySelector('[data-catalog-status]');
      const catalogScopePrefix = root.querySelector('[data-catalog-scope-prefix]');
      const catalogScopeLabel = root.querySelector('[data-catalog-scope-label]');
      const totalPages = Math.max(1, Number(root.dataset.totalPages || 1));
      const currentPage = Math.max(1, Number(root.dataset.currentPage || 1));
      const totalProducts = Math.max(records.length, Number(root.dataset.totalProducts || records.length));
      const sectionId = root.dataset.sectionId;
      const collectionUrl = root.dataset.collectionUrl || window.location.pathname;
      const catalogAbort = new AbortController();
      root._mpAioCatalogAbort = catalogAbort;
      root._mpAioCatalogDisposed = false;
      const state = { search: '', series: 'Alle', module: 'Alle', capacity: 'Alle', price: 'Alle', brand: 'Alle', moduleCount: 'Alle', mount: false, available: false, sort: 'featured', visible: Number(root.dataset.initialProducts || 12), selected: [], subnav: 'all' };
      const subnavButtons = Array.from(root.querySelectorAll('[data-subnav-key]'));
      const subnavId = (button) => button?.dataset.subnavId || (button?.dataset.subnavKey === 'all' ? 'all' : `${button?.dataset.subnavKey}:${normalize(button?.dataset.subnavValue || '')}`);
      state.subnav = subnavId(subnavButtons.find((button) => button.getAttribute('aria-pressed') === 'true')) || 'all';
      const initializeCard = (record) => {
        if (!record.card || record.initialized) return record.card;
        const card = record.card;
        const moduleSummary = card.querySelector('[data-module-summary]');
        const capacitySummary = card.querySelector('[data-capacity-summary]');
        if (moduleSummary && record._modules.length > 0) moduleSummary.textContent = labelList(record._modules, 'Module', moduleSummary.textContent.trim() || 'Modulwahl im Produkt');
        if (capacitySummary) capacitySummary.textContent = labelList(record._capacity, 'kWh', 'Kapazität im Produkt');
        const staticPanelSelector = card.querySelector('[data-static-panel-selector]');
        const staticPanelLabel = staticPanelSelector?.querySelector('[data-static-panel-label]');
        if (staticPanelSelector && staticPanelLabel) {
          const staticQuantity = solarmoduleQuantity(staticPanelLabel.dataset.staticPanelLabel);
          const showStaticPanel = Number.isInteger(staticQuantity) && staticQuantity > 0;
          staticPanelSelector.hidden = !showStaticPanel;
          if (showStaticPanel) staticPanelLabel.textContent = staticQuantity === 1 ? '1 Modul' : `${staticQuantity} Module`;
        }
        const variantData = card.querySelector('[data-variant-data]');
        const selector = card.querySelector('[data-panel-selector]');
        if (variantData) {
          try {
            const config = JSON.parse(variantData.textContent);
            const hasDynamicSelector = Boolean(selector);
            const panelIndex = config.panelOptionIndex == null ? -1 : Number(config.panelOptionIndex);
            const variants = Array.isArray(config.variants) ? config.variants : [];
            const classifications = config.classifications && typeof config.classifications === 'object' ? config.classifications : {};
            const deliveryCountry = String(root.dataset.deliveryCountry || 'DE').toUpperCase();
            const initialVariant = variants.find((variant) => String(variant.id) === String(config.initialVariantId)) || variants[0];
            const initialOptions = initialVariant ? [...initialVariant.options] : [];
            const buttons = selector ? Array.from(selector.querySelectorAll('[data-panel-value]')) : [];
            const renderVariant = (variant) => {
              if (!variant) return;
              const selectedValue = panelIndex >= 0 ? (variant.options[panelIndex] || '') : '';
              const price = card.querySelector('[data-card-price-main]');
              const compare = card.querySelector('[data-card-price-compare]');
              const availability = card.querySelector('[data-card-availability]');
              const availabilityText = availability?.querySelector('b');
              const mediaAvailability = card.querySelector('[data-card-media-availability]');
              const deliveryWrap = card.querySelector('[data-card-delivery]');
              const delivery = card.querySelector('[data-card-delivery-text]');
              const taxPrice = card.querySelector('[data-product-price]');
              const saleBadge = card.querySelector('[data-card-sale]');
              const hasCompare = Number(variant.compareAtPrice) > Number(variant.price);
              const deliveryResult = resolveDelivery(variant, deliveryCountry, classifications);
              const availabilityLabel = shippingDelivery
                ? shippingDelivery.availabilityText(deliveryResult, { available: Boolean(variant.available) })
                : (variant.available ? 'Verfügbar' : 'Derzeit nicht verfügbar');
              const deliveryNeedsAttention = deliveryResult.status !== 'ok'
                || deliveryResult.mode === 'preorder'
                || (!variant.available && deliveryResult.mode !== 'preorder');
              if (hasDynamicSelector && price) price.textContent = variant.priceText;
              if (hasDynamicSelector && compare) {
                compare.hidden = !hasCompare;
                compare.textContent = hasCompare ? variant.compareAtText : '';
              }
              if (availability) availability.classList.toggle('is-request', deliveryNeedsAttention);
              if (availabilityText) availabilityText.textContent = availabilityLabel;
              if (mediaAvailability) {
                mediaAvailability.textContent = availabilityLabel;
                mediaAvailability.classList.toggle('is-preorder', deliveryResult.mode === 'preorder');
                mediaAvailability.classList.toggle('is-sold-out', deliveryResult.mode !== 'preorder' && !variant.available);
                mediaAvailability.setAttribute('aria-label', `Produktdetails öffnen: ${availabilityLabel}`);
              }
              if (delivery) delivery.textContent = deliveryText(variant, deliveryCountry, classifications);
              if (deliveryWrap) deliveryWrap.classList.toggle('is-request', deliveryNeedsAttention);
              const variantUrl = `${card.dataset.url}?variant=${encodeURIComponent(variant.id)}`;
            card.querySelectorAll('[data-card-variant-link]').forEach((link) => { link.href = variantUrl; });
              const variantDataset = {
                price: String(variant.price),
                available: String(Boolean(variant.available)),
                sale: String(hasCompare),
                mpTaxVariantId: String(variant.id),
                mpTaxMode: String(variant.taxMode || '')
              };
              if (hasDynamicSelector) {
                Object.assign(record.dataset, variantDataset);
                Object.assign(card.dataset, variantDataset);
                if (taxPrice) taxPrice.dataset.mpTaxDefaultVariantId = String(variant.id);
                updateTaxNote(card);
                if (saleBadge) saleBadge.hidden = !hasCompare;
                buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.panelValue === selectedValue)));
                if (record.initialized) {
                  document.dispatchEvent(new CustomEvent('mp:tax-content-ready', { detail: { root: card } }));
                }
              }
            };
            const selectVariant = (panelValue) => {
              const hasPanelValue = (variant) => variant.options[panelIndex] === panelValue;
              const keepsInitialOptions = (variant) => variant.options.every((value, index) => index === panelIndex || value === initialOptions[index]);
              return variants.find((variant) => variant.available && hasPanelValue(variant) && keepsInitialOptions(variant))
                || variants.find((variant) => hasPanelValue(variant) && keepsInitialOptions(variant))
                || variants.find((variant) => variant.available && hasPanelValue(variant))
                || variants.find(hasPanelValue);
            };
            buttons.forEach((button) => {
              const quantity = solarmoduleQuantity(button.dataset.panelValue);
              if (quantity !== null) button.textContent = quantity === 1 ? '1 Modul' : `${quantity} Module`;
            });
            if (hasDynamicSelector) card._mpPanelSelector = { renderVariant, selectVariant };
            renderVariant(initialVariant);
          } catch (error) {
            if (selector) selector.hidden = true;
          }
        }
        const compareButton = card.querySelector('[data-compare]');
        if (compareButton) {
          const selected = state.selected.includes(record.dataset.handle);
          compareButton.classList.toggle('is-selected', selected);
          compareButton.textContent = selected ? '✓ Verglichen' : '+ Vergleichen';
        }
        record.initialized = true;
        updateTaxNote(card);
        document.dispatchEvent(new CustomEvent('mp:tax-content-ready', { detail: { root: card } }));
        return card;
      };
      const ensureCard = (record) => {
        if (!record.card) {
          const source = record.template?.content.querySelector('[data-card]');
          if (!source) return null;
          record.card = source.cloneNode(true);
          record.template.remove();
          record.template = null;
        }
        return initializeCard(record);
      };
      records.filter((record) => record.card).forEach(initializeCard);
      connectTaxNotes(root, records);
      const refreshBrandOptions = () => {
        const selectedBrand = state.brand;
        const brands = records.reduce((map, record) => {
          const brand = record.dataset.brand;
          if (brand) map.set(brand, (map.get(brand) || 0) + 1);
          return map;
        }, new Map());
        const allOption = document.createElement('option');
        allOption.value = 'Alle';
        allOption.textContent = 'Alle';
        const options = [...brands.entries()].sort((a, b) => b[1] - a[1]).map(([brand, count]) => {
          const option = document.createElement('option');
          option.value = brand;
          option.textContent = `${brand} (${count})`;
          return option;
        });
        brandSelect.replaceChildren(allOption, ...options);
        brandSelect.value = options.some((option) => option.value === selectedBrand) ? selectedBrand : 'Alle';
        state.brand = brandSelect.value;
      };
      const materialTemplateIds = new Set(Array.from(root.querySelectorAll('template[data-material-template]'), (template) => template.dataset.materialTemplate));
      const pageUrl = (page) => {
        const url = new URL(collectionUrl, window.location.origin);
        const current = new URL(window.location.href);
        current.searchParams.forEach((value, key) => {
          if (key !== 'page' && key !== 'section_id' && key !== 'view') url.searchParams.append(key, value);
        });
        url.searchParams.set('view', root.dataset.view || 'mp-allinone');
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', sectionId);
        return url;
      };
      const fetchCatalogPage = async (page) => {
        const timeout = window.setTimeout(() => catalogAbort.abort(), 20000);
        let response;
        try {
          response = await fetch(pageUrl(page), {
            cache: 'no-store',
            credentials: 'same-origin',
            signal: catalogAbort.signal,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
        } catch (error) {
          if (error?.name === 'AbortError' && root.isConnected) throw new Error(`Katalogseite ${page}: Zeitüberschreitung`);
          throw error;
        } finally {
          window.clearTimeout(timeout);
        }
        if (!response.ok) throw new Error(`Katalogseite ${page}: HTTP ${response.status}`);
        const documentPage = new DOMParser().parseFromString(await response.text(), 'text/html');
        const remoteRoot = documentPage.querySelector('[data-mp-aio]');
        const remoteGrid = remoteRoot?.querySelector('[data-grid]');
        if (!remoteRoot || !remoteGrid) throw new Error(`Katalogseite ${page}: Abschnitt fehlt`);
        const remotePage = Number(remoteRoot.dataset.currentPage || 0);
        const remotePages = Number(remoteRoot.dataset.totalPages || 0);
        const remoteTotal = Number(remoteRoot.dataset.totalProducts || 0);
        if (remoteRoot.dataset.view !== (root.dataset.view || 'mp-allinone')) throw new Error(`Katalogseite ${page}: falsche Ansicht`);
        if (remoteRoot.dataset.sectionId !== sectionId) throw new Error(`Katalogseite ${page}: falscher Abschnitt`);
        if (remotePage !== page) throw new Error(`Katalogseite ${page}: falsche Seitennummer ${remotePage}`);
        if (remotePages !== totalPages || remoteTotal !== totalProducts) throw new Error(`Katalogseite ${page}: Katalogumfang hat sich geändert`);
        const cards = Array.from(remoteGrid.querySelectorAll(':scope > [data-card]'), (card) => {
          const clone = card.cloneNode(true);
          clone.querySelectorAll('img').forEach((image) => {
            image.setAttribute('loading', 'lazy');
            image.removeAttribute('fetchpriority');
          });
          return clone;
        });
        const templates = Array.from(remoteGrid.querySelectorAll(':scope > template[data-card-template]'), (template) => template.cloneNode(true));
        const pageSize = Math.max(1, Number(remoteRoot.dataset.initialProducts || root.dataset.initialProducts || 12));
        const expectedProducts = page < totalPages ? pageSize : totalProducts - (pageSize * (totalPages - 1));
        const pageHandles = [...cards, ...templates].map((entry) => entry.dataset.handle).filter(Boolean);
        if (pageHandles.length !== expectedProducts || new Set(pageHandles).size !== expectedProducts) {
          throw new Error(`Katalogseite ${page}: erwartete ${expectedProducts}, erhielt ${pageHandles.length} eindeutige Produkte`);
        }
        return {
          page,
          cards,
          templates,
          materialTemplates: Array.from(remoteRoot.querySelectorAll('template[data-material-template]'), (template) => template.cloneNode(true)),
        };
      };
      const ingestPage = (pageData) => {
        pageData.cards.forEach((card) => {
          if (recordByHandle.has(card.dataset.handle)) return;
          const record = createRecord(card, card);
          records.push(record);
          recordByHandle.set(record.dataset.handle, record);
        });
        pageData.templates.forEach((template) => {
          if (recordByHandle.has(template.dataset.handle)) return;
          const record = createRecord(template, null, template);
          records.push(record);
          recordByHandle.set(record.dataset.handle, record);
        });
        pageData.materialTemplates.forEach((template) => {
          const id = template.dataset.materialTemplate;
          if (!id || materialTemplateIds.has(id)) return;
          materialTemplateIds.add(id);
          root.append(template);
        });
      };
      const updateGlobalCounts = () => {
        const brands = new Set(records.map((record) => record.dataset.brand).filter(Boolean));
        const availableCount = records.filter((record) => record.dataset.available === 'true').length;
        const imageCount = records.reduce((sum, record) => sum + Number(record.dataset.imageCount || 0), 0);
        const variantCount = records.reduce((sum, record) => sum + Number(record.dataset.variantCount || 0), 0);
        const descriptionCount = records.filter((record) => record.dataset.hasDescription === 'true').length;
        const deliveryCount = records.filter((record) => record.dataset.hasDelivery === 'true').length;
        root.querySelectorAll('[data-global-product-count]').forEach((node) => { node.textContent = totalProducts; });
        root.querySelectorAll('[data-global-brand-count]').forEach((node) => { node.textContent = brands.size; });
        root.querySelectorAll('[data-global-available-count]').forEach((node) => { node.textContent = availableCount; });
        root.querySelectorAll('[data-global-image-count]').forEach((node) => { node.textContent = imageCount; });
        root.querySelectorAll('[data-global-variant-count]').forEach((node) => { node.textContent = variantCount; });
        root.querySelectorAll('[data-global-description-count]').forEach((node) => { node.textContent = descriptionCount; });
        root.querySelectorAll('[data-global-delivery-count]').forEach((node) => { node.textContent = deliveryCount; });
        root.querySelectorAll('[data-global-series-count]').forEach((node) => {
          node.textContent = records.filter((record) => record.dataset.series === node.dataset.globalSeriesCount).length;
        });
        root.querySelectorAll('[data-global-module-count]').forEach((node) => {
          node.textContent = records.filter((record) => record.dataset.module === node.dataset.globalModuleCount).length;
        });
      };
      const loadedPages = new Set([currentPage]);
      const pagePromises = new Map();
      let catalogPromise = null;
      let catalogReady = totalPages === 1 && records.length === totalProducts;
      let catalogFailed = false;
      const setCatalogScope = (stateName) => {
        root.dataset.catalogState = stateName;
        if (!catalogScopePrefix || !catalogScopeLabel) return;
        if (stateName === 'ready') {
          catalogScopePrefix.textContent = 'Produkte im';
          catalogScopeLabel.textContent = 'Sortiment';
          return;
        }
        if (stateName === 'failed') {
          catalogScopePrefix.textContent = `von ${totalProducts} Produkten`;
          catalogScopeLabel.textContent = 'geladen · unvollständig';
          return;
        }
        catalogScopePrefix.textContent = 'Produkte werden';
        catalogScopeLabel.textContent = 'geladen';
      };
      const refreshCatalogDerivedData = () => {
        records.sort((a, b) => Number(a.dataset.index || 0) - Number(b.dataset.index || 0));
        refreshBrandOptions();
        if (!catalogReady) return;
        catalogFailed = false;
        root.dataset.catalogReady = 'true';
        setCatalogScope('ready');
        updateGlobalCounts();
        if (nativePagination) nativePagination.hidden = true;
        if (catalogStatus) catalogStatus.textContent = `Alle ${totalProducts} Sets werden durchsucht.`;
      };
      const fetchAndIngestPage = async (page) => {
        if (loadedPages.has(page)) return true;
        let pagePromise = pagePromises.get(page);
        if (!pagePromise) {
          pagePromise = fetchCatalogPage(page);
          pagePromises.set(page, pagePromise);
        }
        let pageData;
        try {
          pageData = await pagePromise;
        } finally {
          pagePromises.delete(page);
        }
        if (!loadedPages.has(page)) {
          ingestPage(pageData);
          loadedPages.add(page);
          catalogReady = loadedPages.size >= totalPages && records.length === totalProducts;
          refreshCatalogDerivedData();
        }
        return true;
      };
      const showCatalogFailure = (error) => {
        console.error('[Mini Power AllinOne] Gesamtkatalog konnte nicht geladen werden.', error);
        catalogFailed = true;
        catalogReady = false;
        root.dataset.catalogReady = 'false';
        setCatalogScope('failed');
        if (nativePagination) nativePagination.hidden = false;
        if (catalogStatus) {
          catalogStatus.setAttribute('aria-live', 'polite');
          catalogStatus.textContent = `${records.length} von ${totalProducts} Produkten wurden geladen. Der Gesamtkatalog ist unvollständig; die Seitennavigation bleibt verfügbar.`;
        }
      };
      const ensureFullCatalog = () => {
        if (catalogReady) return Promise.resolve(true);
        if (catalogPromise) return catalogPromise;
        catalogFailed = false;
        root.setAttribute('aria-busy', 'true');
        setCatalogScope('loading');
        if (nativePagination) nativePagination.hidden = false;
        loadMore.hidden = true;
        if (catalogStatus) {
          catalogStatus.setAttribute('aria-live', 'off');
          catalogStatus.textContent = 'Gesamtkatalog wird geladen …';
        }
        const pages = Array.from({ length: totalPages }, (_, index) => index + 1).filter((page) => !loadedPages.has(page));
        catalogPromise = Promise.allSettled(pages.map(fetchCatalogPage))
          .then((results) => {
            const failures = results.filter((result) => result.status === 'rejected');
            if (failures.length) throw failures[0].reason;
            const pageDataList = results.map((result) => result.value).sort((a, b) => a.page - b.page);
            const catalogHandles = new Set(recordByHandle.keys());
            pageDataList.forEach((pageData) => {
              [...pageData.cards, ...pageData.templates].forEach((source) => {
                const handle = source.dataset.handle;
                if (!handle || catalogHandles.has(handle)) throw new Error(`Katalogseite ${pageData.page}: Produkt ${handle || '?'} wurde doppelt geliefert`);
                catalogHandles.add(handle);
              });
            });
            pageDataList.forEach((pageData) => {
              ingestPage(pageData);
              loadedPages.add(pageData.page);
            });
            catalogReady = loadedPages.size >= totalPages && records.length === totalProducts;
            if (!catalogReady) throw new Error(`Katalogumfang unvollständig: ${records.length} von ${totalProducts} Produkten`);
            refreshCatalogDerivedData();
            return catalogReady;
          })
          .catch((error) => {
            if (root._mpAioCatalogDisposed || !root.isConnected) return false;
            showCatalogFailure(error);
            return false;
          })
          .finally(() => {
            catalogPromise = null;
            root.removeAttribute('aria-busy');
          });
        return catalogPromise;
      };
      const nextCatalogPage = () => {
        for (let page = currentPage + 1; page <= totalPages; page += 1) {
          if (!loadedPages.has(page)) return page;
        }
        for (let page = 1; page <= currentPage; page += 1) {
          if (!loadedPages.has(page)) return page;
        }
        return null;
      };
      const ensureNextCatalogPage = async () => {
        if (catalogReady) return true;
        const page = nextCatalogPage();
        if (!page) return catalogReady;
        root.setAttribute('aria-busy', 'true');
        if (catalogStatus) catalogStatus.textContent = `Weitere Sets werden geladen (Seite ${page} von ${totalPages}) …`;
        try {
          await fetchAndIngestPage(page);
          if (!catalogReady && catalogStatus) catalogStatus.textContent = `${records.length} von ${totalProducts} Sets sind geladen.`;
          return true;
        } catch (error) {
          if (root._mpAioCatalogDisposed || !root.isConnected) return false;
          showCatalogFailure(error);
          return false;
        } finally {
          root.removeAttribute('aria-busy');
        }
      };
      refreshBrandOptions();
      if (catalogReady) refreshCatalogDerivedData();
      else {
        root.dataset.catalogReady = 'false';
        setCatalogScope('loading');
        if (nativePagination) nativePagination.hidden = false;
      }
      const capacityMatch = (values) => state.capacity === 'Alle' || (state.capacity === 'bis-2' ? values.some((value) => value <= 2) : state.capacity === '2-bis-5' ? values.some((value) => value > 2 && value <= 5) : state.capacity === '5-bis-10' ? values.some((value) => value > 5 && value <= 10) : values.some((value) => value > 10));
      const priceMatch = (cents) => state.price === 'Alle' || (state.price === 'unter-1000' ? cents < 100000 : state.price === '1000-bis-2000' ? cents >= 100000 && cents < 200000 : cents >= 200000);
      const matches = (record) => (!state.search || normalize(record.dataset.search).includes(normalize(state.search))) && (state.series === 'Alle' || record.dataset.series === state.series) && (state.module === 'Alle' || record.dataset.module === state.module) && capacityMatch(record._capacity) && priceMatch(Number(record.dataset.price)) && (state.brand === 'Alle' || record.dataset.brand === state.brand) && (state.moduleCount === 'Alle' || record._modules.includes(Number(state.moduleCount))) && (!state.mount || record.dataset.mount === 'true') && (!state.available || record.dataset.available === 'true');
      const filterLabels = { series: 'System', module: 'Solarmodul', capacity: 'Kapazität', price: 'Startpreis', brand: 'Marke', moduleCount: 'Modulanzahl' };
      const renderActive = () => {
        activeRow.querySelectorAll('button').forEach((button) => button.remove());
        const active = [];
        ['series', 'module', 'capacity', 'price', 'brand', 'moduleCount'].forEach((key) => { if (state[key] !== 'Alle') active.push([key, state[key]]); });
        if (state.mount) active.push(['mount', 'Halterung']);
        if (state.available) active.push(['available', 'Verfügbar']);
        if (state.search) active.push(['search', `„${state.search}“`]);
        activeRow.hidden = active.length === 0;
        active.forEach(([key, value]) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.clearKey = key;
          button.textContent = `${filterLabels[key] ? `${filterLabels[key]}: ` : ''}${value} ×`;
          activeRow.append(button);
        });
      };
      const hasActiveCatalogCriteria = () => Boolean(state.search)
        || state.series !== 'Alle'
        || state.module !== 'Alle'
        || state.capacity !== 'Alle'
        || state.price !== 'Alle'
        || state.brand !== 'Alle'
        || state.moduleCount !== 'Alle'
        || state.mount
        || state.available;
      const apply = () => transition(() => {
        const filtered = records.filter(matches);
        const ordered = [...filtered];
        if (state.sort === 'price-up') ordered.sort((a, b) => Number(a.dataset.price) - Number(b.dataset.price));
        if (state.sort === 'price-down') ordered.sort((a, b) => Number(b.dataset.price) - Number(a.dataset.price));
        if (state.sort === 'name') ordered.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title, 'de'));
        if (state.sort === 'featured') ordered.sort((a, b) => Number(a.dataset.index) - Number(b.dataset.index));
        const visibleRecords = catalogReady ? ordered : ordered.slice(0, state.visible);
        const visibleCards = visibleRecords.map(ensureCard).filter(Boolean);
        const detachedCards = document.createDocumentFragment();
        records.forEach((record) => {
          const card = record.card;
          if (!card) return;
          card.hidden = true;
          if (card.parentNode === grid) detachedCards.append(card);
        });
        const nextCards = document.createDocumentFragment();
        visibleCards.forEach((card) => {
          card.hidden = false;
          nextCards.append(card);
        });
        grid.append(nextCards);
        const resultTotal = catalogReady
          ? filtered.length
          : (hasActiveCatalogCriteria() ? filtered.length : (catalogFailed ? records.length : totalProducts));
        root.querySelectorAll('[data-filter-count],[data-result-count]').forEach((node) => { node.textContent = resultTotal; });
        const incompleteResult = catalogFailed && hasActiveCatalogCriteria();
        root.querySelector('[data-empty]').hidden = incompleteResult || resultTotal !== 0;
        loadMore.hidden = true;
        root.querySelector('[data-remaining]').textContent = '';
        renderActive();
        syncButtons();
        root.querySelector('[data-filter-open]').textContent = `☷ Filter${activeRow.hidden ? '' : ` (${activeRow.querySelectorAll('button').length})`}`;
      });
      const syncButtons = () => {
        root.querySelectorAll('[data-filter-key]').forEach((button) => {
          const selected = state[button.dataset.filterKey] === button.dataset.filterValue;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
        });
        const allSetsMustBeReleased = state.subnav === 'all' && hasActiveCatalogCriteria();
        subnavButtons.forEach((button) => {
          const selected = subnavId(button) === state.subnav && !allSetsMustBeReleased;
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
          button.removeAttribute('aria-selected');
        });
      };
      const alignSubnavWithFilters = (preferredKey = '') => {
        const keys = preferredKey === 'module' ? ['module', 'series'] : ['series', 'module'];
        const matchingButton = keys.reduce((match, key) => match || subnavButtons.find((button) => (
          button.dataset.subnavKey === key
          && state[key] !== 'Alle'
          && button.dataset.subnavValue === state[key]
        )), null);
        const hasCategoryFilter = state.series !== 'Alle' || state.module !== 'Alle';
        state.subnav = subnavId(matchingButton) || (hasCategoryFilter ? 'filtered' : 'all');
      };
      const applyAfterCatalog = async () => {
        const ready = await ensureFullCatalog();
        apply();
        return ready;
      };
      const activateSubnav = (button, { scroll = true } = {}) => {
        if (!button) return;
        if (button.dataset.subnavKey === 'all') {
          state.series = 'Alle';
          state.module = 'Alle';
        } else {
          state[button.dataset.subnavKey] = button.dataset.subnavValue;
          if (button.dataset.subnavKey === 'series') state.module = 'Alle';
          if (button.dataset.subnavKey === 'module') state.series = 'Alle';
        }
        state.subnav = subnavId(button);
        state.visible = Number(root.dataset.initialProducts || 12);
        syncButtons();
        applyAfterCatalog();
        if (scroll) root.querySelector('#mp-allinone-products')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      let loadMorePromise = null;
      const loadMoreProducts = () => {
        if (loadMorePromise) return loadMorePromise;
        const button = loadMore.querySelector('button');
        loadMore.setAttribute('aria-busy', 'true');
        if (button) button.disabled = true;
        loadMorePromise = (async () => {
          const ready = await ensureFullCatalog();
          apply();
          return ready;
        })().finally(() => {
          loadMorePromise = null;
          loadMore.removeAttribute('aria-busy');
          if (button) button.disabled = false;
        });
        return loadMorePromise;
      };
      const reset = () => {
        Object.assign(state, { search: '', series: 'Alle', module: 'Alle', capacity: 'Alle', price: 'Alle', brand: 'Alle', moduleCount: 'Alle', mount: false, available: false, sort: 'featured', visible: Number(root.dataset.initialProducts || 12), subnav: 'all' });
        search.value = ''; sort.value = 'featured'; brandSelect.value = 'Alle'; moduleCountSelect.value = 'Alle'; mount.checked = false; available.checked = false; syncButtons(); renderActive(); applyAfterCatalog();
      };
      const searchForm = search.closest('form');
      const buildSearchUrl = () => {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const fallbackAction = `${shopRoot.replace(/\/?$/, '/')}search`;
        const searchUrl = new URL(searchForm?.getAttribute('action') || fallbackAction, window.location.origin);
        searchUrl.search = new URLSearchParams(new FormData(searchForm)).toString();
        return searchUrl.toString();
      };
      const syncSearchSubmit = () => { if (searchSubmit) searchSubmit.href = buildSearchUrl(); };
      syncSearchSubmit();
      if (searchForm) searchForm.addEventListener('submit', (event) => {
        event.preventDefault();
        event.stopPropagation();
        state.search = search.value.trim();
        state.visible = Number(root.dataset.initialProducts || 12);
        applyAfterCatalog();
      });
      const openFilters = () => { filters.classList.add('is-open'); backdrop.hidden = false; document.documentElement.style.overflow = 'hidden'; };
      const closeFilters = () => { filters.classList.remove('is-open'); backdrop.hidden = true; document.documentElement.style.overflow = ''; };
      const primeBrandCatalog = () => { ensureFullCatalog(); };
      brandSelect.addEventListener('pointerdown', primeBrandCatalog, { once: true });
      brandSelect.addEventListener('focus', primeBrandCatalog, { once: true });
      const shippingDialog = root.querySelector('[data-shipping-dialog]');
      let shippingOpener = null;
      let searchTimer = 0;
      let activeMaterialDialog = null;
      const materialThumbs = (dialog) => Array.from(dialog?.querySelectorAll('[data-material-thumb]') || []);
      const materialIndex = (dialog) => {
        const index = Number.parseInt(dialog?.dataset.materialIndex || '0', 10);
        return Number.isFinite(index) ? index : 0;
      };
      const setMaterialImage = (dialog, requestedIndex, { focusThumb = false, scrollThumb = true } = {}) => {
        if (!dialog) return false;
        const thumbs = materialThumbs(dialog);
        if (!thumbs.length) {
          dialog.querySelectorAll('[data-material-prev],[data-material-next]').forEach((button) => {
            button.disabled = true;
            button.setAttribute('aria-disabled', 'true');
          });
          return false;
        }
        const index = ((Number(requestedIndex) % thumbs.length) + thumbs.length) % thumbs.length;
        const thumb = thumbs[index];
        const image = dialog.querySelector('.mp-aio-material-image') || dialog.querySelector('.mp-aio-material-main img');
        const nextSource = thumb.dataset.src;
        if (image && nextSource) {
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.setAttribute('src', nextSource);
          image.alt = thumb.dataset.alt || '';
          image.dataset.materialIndex = String(index);
        }
        dialog.dataset.materialIndex = String(index);
        thumbs.forEach((candidate, candidateIndex) => {
          const selected = candidateIndex === index;
          candidate.classList.toggle('is-active', selected);
          candidate.setAttribute('aria-selected', String(selected));
          candidate.tabIndex = selected ? 0 : -1;
        });
        const counter = dialog.querySelector('[data-material-counter]') || dialog.querySelector('.mp-aio-material-main > span');
        if (counter) counter.textContent = `${index + 1} / ${thumbs.length}`;
        dialog.querySelectorAll('[data-material-prev],[data-material-next]').forEach((button) => {
          button.disabled = thumbs.length < 2;
          button.setAttribute('aria-disabled', String(thumbs.length < 2));
        });
        if (scrollThumb) thumb.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        if (focusThumb) thumb.focus({ preventScroll: true });
        return true;
      };
      const stepMaterialImage = (dialog, step, options) => setMaterialImage(dialog, materialIndex(dialog) + step, options);
      const initializeMaterialDialog = (dialog) => {
        const thumbs = materialThumbs(dialog);
        thumbs.forEach((thumb, index) => {
          if (!thumb.dataset.materialIndex) thumb.dataset.materialIndex = String(index);
        });
        const initiallyActive = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
        setMaterialImage(dialog, initiallyActive, { scrollThumb: false });
        const stage = dialog.querySelector('[data-material-stage]');
        if (!stage) return;
        let swipe = null;
        stage.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse') return;
          swipe = { id: event.pointerId, x: event.clientX, y: event.clientY };
        });
        stage.addEventListener('pointerup', (event) => {
          if (!swipe || swipe.id !== event.pointerId) return;
          const deltaX = event.clientX - swipe.x;
          const deltaY = event.clientY - swipe.y;
          swipe = null;
          if (Math.abs(deltaX) < 48 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          stepMaterialImage(dialog, deltaX < 0 ? 1 : -1);
        });
        stage.addEventListener('pointercancel', () => { swipe = null; });
      };
      const openMaterialDialog = (button) => {
        if (activeMaterialDialog?.isConnected && activeMaterialDialog.open) {
          activeMaterialDialog.querySelector('[data-dialog-close]')?.focus();
          return;
        }
        activeMaterialDialog?.remove();
        activeMaterialDialog = null;
        const dialogId = button.dataset.materialOpen;
        const template = root.querySelector(`template[data-material-template="${CSS.escape(dialogId)}"]`);
        const source = template?.content.querySelector('dialog');
        if (!source) return;
        const dialog = source.cloneNode(true);
        dialog.dataset.dynamicMaterial = 'true';
        dialog.dataset.materialTemplateId = dialogId;
        activeMaterialDialog = dialog;
        root.append(dialog);
        dialog.scrollTop = 0;
        const copy = dialog.querySelector('.mp-aio-material-copy');
        if (copy) copy.scrollTop = 0;
        initializeMaterialDialog(dialog);
        dialog.addEventListener('close', () => {
          if (activeMaterialDialog === dialog) activeMaterialDialog = null;
          dialog.remove();
          if (button.isConnected) button.focus();
        }, { once: true });
        try {
          dialog.showModal();
        } catch (error) {
          if (activeMaterialDialog === dialog) activeMaterialDialog = null;
          dialog.remove();
          console.error('[Mini Power AllinOne] Materialansicht konnte nicht geöffnet werden.', error);
        }
      };
      const openShippingDialog = (button) => {
        if (!shippingDialog) return;
        const card = button.closest('[data-card]');
        const taxNote = card?.querySelector('[data-card-price-note]')?.textContent?.trim();
        const deliveryNote = card?.querySelector('[data-card-delivery-text]')?.textContent?.trim();
        const taxSelector = document.querySelector('#mp-tax-selector');
        const countryLabel = document.querySelector('#mp-tax-country option:checked')?.textContent?.trim();
        const role = taxSelector?.querySelector('[data-mp-tax-role][aria-pressed="true"]')?.dataset.mpTaxRole;
        const roleLabel = role === 'business' ? 'Geschäftskunde' : role === 'private' ? 'Privatkunde' : '';
        shippingDialog.querySelector('[data-shipping-context]').textContent = ['Aktuelle Auswahl', countryLabel, roleLabel].filter(Boolean).join(' · ');
        shippingDialog.querySelector('[data-shipping-tax-note]').textContent = taxNote || 'Preis gemäß aktueller Shop-Einstellung';
        shippingDialog.querySelector('[data-shipping-delivery-note]').textContent = deliveryNote || 'Lieferzeit: auf der Produktseite prüfen';
        shippingDialog.scrollTop = 0;
        shippingOpener = button;
        shippingDialog.showModal();
      };
      root.addEventListener('keydown', (event) => {
        const subnavButton = event.target.closest?.('[data-subnav-key]');
        if (subnavButton && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          const currentIndex = Math.max(0, subnavButtons.indexOf(subnavButton));
          const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? subnavButtons.length - 1 : event.key === 'ArrowRight' ? (currentIndex + 1) % subnavButtons.length : (currentIndex - 1 + subnavButtons.length) % subnavButtons.length;
          const nextButton = subnavButtons[nextIndex];
          nextButton?.focus();
          activateSubnav(nextButton, { scroll: false });
          return;
        }
        const materialDialog = event.target.closest?.('.mp-aio-material-dialog');
        const materialGallery = event.target.closest?.('.mp-aio-material-gallery');
        if (materialDialog && materialGallery && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          const thumbs = materialThumbs(materialDialog);
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? thumbs.length - 1 : materialIndex(materialDialog) + (event.key === 'ArrowRight' ? 1 : -1);
          setMaterialImage(materialDialog, index, { focusThumb: Boolean(event.target.closest?.('[data-material-thumb]')) });
          return;
        }
        if (event.target === search && event.key === 'Enter') {
          event.preventDefault();
          state.search = search.value.trim();
          state.visible = Number(root.dataset.initialProducts || 12);
          applyAfterCatalog();
        }
      });
      root.addEventListener('input', (event) => {
        if (event.target !== search) return;
        syncSearchSubmit();
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(() => {
          state.search = search.value.trim();
          state.visible = Number(root.dataset.initialProducts || 12);
          applyAfterCatalog();
        }, 180);
      });
      root.addEventListener('change', (event) => {
        if (event.target === sort) state.sort = sort.value;
        else if (event.target === brandSelect) state.brand = brandSelect.value;
        else if (event.target === moduleCountSelect) state.moduleCount = moduleCountSelect.value;
        else if (event.target === mount) state.mount = mount.checked;
        else if (event.target === available) state.available = available.checked;
        else return;
        state.visible = Number(root.dataset.initialProducts || 12);
        applyAfterCatalog();
      });
      root.addEventListener('click', async (event) => {
        const target = event.target;
        const panelButton = target.closest('[data-panel-value]');
        if (panelButton) {
          const card = panelButton.closest('[data-card]');
          const panel = card?._mpPanelSelector;
          if (panel) {
            const variant = panel.selectVariant(panelButton.dataset.panelValue);
            const requestId = Number(card._mpTaxVariantRequestId || 0) + 1;
            card._mpTaxVariantRequestId = requestId;
            if (!variant || String(card.dataset.mpTaxVariantId || '') === String(variant.id)) {
              card.removeAttribute('aria-busy');
              return;
            }
            card.setAttribute('aria-busy', 'true');
            const taxReady = await ensureTaxVariant(card, variant);
            if (card._mpTaxVariantRequestId !== requestId) return;
            card.removeAttribute('aria-busy');
            if (!taxReady) return;
            panel.renderVariant(variant);
            apply();
          }
          return;
        }
        const filterButton = target.closest('[data-filter-key]');
        if (filterButton) {
          const filterKey = filterButton.dataset.filterKey;
          state[filterKey] = filterButton.dataset.filterValue;
          if (filterKey === 'series' || filterKey === 'module') alignSubnavWithFilters(filterKey);
          state.visible = Number(root.dataset.initialProducts || 12);
          syncButtons();
          applyAfterCatalog();
          return;
        }
        const subnavButton = target.closest('[data-subnav-key]');
        if (subnavButton) {
          activateSubnav(subnavButton);
          return;
        }
        const clearButton = target.closest('[data-clear-key]');
        if (clearButton) {
          const key = clearButton.dataset.clearKey;
          if (key === 'search') {
            state.search = '';
            search.value = '';
          } else if (key === 'mount' || key === 'available') {
            state[key] = false;
            root.querySelector(`[data-${key}]`).checked = false;
          } else {
            state[key] = 'Alle';
            if (key === 'brand') brandSelect.value = 'Alle';
            if (key === 'moduleCount') moduleCountSelect.value = 'Alle';
          }
          if (key === 'series' || key === 'module') alignSubnavWithFilters(key === 'series' ? 'module' : 'series');
          state.visible = Number(root.dataset.initialProducts || 12);
          syncButtons();
          applyAfterCatalog();
          return;
        }
        if (target.closest('[data-search-clear]')) {
          event.preventDefault();
          window.clearTimeout(searchTimer);
          search.value = '';
          state.search = '';
          state.visible = Number(root.dataset.initialProducts || 12);
          syncSearchSubmit();
          applyAfterCatalog();
          search.focus();
          return;
        }
        if (target.closest('[data-search-submit]')) {
          event.preventDefault();
          state.search = search.value.trim();
          state.visible = Number(root.dataset.initialProducts || 12);
          applyAfterCatalog();
          return;
        }
        if (target.closest('[data-reset]')) { reset(); return; }
        if (target.closest('[data-scroll-products]')) {
          root.querySelector('#mp-allinone-products').scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        if (target.closest('[data-load-more] button')) {
          loadMoreProducts();
          return;
        }
        if (target.closest('[data-filter-open]')) { openFilters(); return; }
        if (target.closest('[data-filter-close]') || target.closest('[data-filter-backdrop]')) { closeFilters(); return; }
        const materialButton = target.closest('[data-material-open]');
        if (materialButton) { openMaterialDialog(materialButton); return; }
        const shippingButton = target.closest('[data-shipping-payment-open]');
        if (shippingButton) { openShippingDialog(shippingButton); return; }
        const closeButton = target.closest('[data-dialog-close]');
        if (closeButton) { closeButton.closest('dialog')?.close(); return; }
        const materialStepButton = target.closest('[data-material-prev],[data-material-next]');
        if (materialStepButton) {
          const dialog = materialStepButton.closest('.mp-aio-material-dialog');
          stepMaterialImage(dialog, materialStepButton.matches('[data-material-next]') ? 1 : -1);
          return;
        }
        const thumbButton = target.closest('[data-material-thumb]');
        if (thumbButton) {
          const dialog = thumbButton.closest('.mp-aio-material-dialog');
          const index = Number.parseInt(thumbButton.dataset.materialIndex || '', 10);
          setMaterialImage(dialog, Number.isFinite(index) ? index : materialThumbs(dialog).indexOf(thumbButton));
          return;
        }
        if (target.matches('dialog')) target.close();
      });
      shippingDialog?.addEventListener('close', () => { shippingOpener?.focus(); shippingOpener = null; });
      const tray = root.querySelector('[data-compare-tray]');
      const compareItems = root.querySelector('[data-compare-items]');
      const compareOpen = root.querySelector('[data-compare-open]');
      const compareDialog = root.querySelector('[data-compare-dialog]');
      const compareNotice = root.querySelector('[data-compare-notice]');
      const renderCompare = () => {
        compareItems.replaceChildren();
        state.selected.forEach((handle) => { const record = recordByHandle.get(handle); if (!record) return; const button = document.createElement('button'); button.type = 'button'; button.dataset.removeCompare = handle; const span = document.createElement('span'); span.textContent = record.dataset.title; const close = document.createElement('i'); close.textContent = '×'; button.append(span, close); compareItems.append(button); });
        root.querySelector('[data-compare-count]').textContent = state.selected.length; tray.hidden = state.selected.length === 0; compareOpen.disabled = state.selected.length < 2;
        records.forEach((record) => { const button = record.card?.querySelector('[data-compare]'); if (!button) return; const selected = state.selected.includes(record.dataset.handle); button.classList.toggle('is-selected', selected); button.textContent = selected ? '✓ Verglichen' : '+ Vergleichen'; });
      };
      root.addEventListener('click', (event) => { const button = event.target.closest('[data-compare]'); if (!button) return; const card = button.closest('[data-card]'); const handle = card.dataset.handle; if (state.selected.includes(handle)) state.selected = state.selected.filter((value) => value !== handle); else if (state.selected.length >= 3) { compareNotice.hidden = false; compareNotice.textContent = 'Maximal drei Sets gleichzeitig vergleichen.'; return; } else state.selected.push(handle); compareNotice.hidden = true; renderCompare(); });
      compareItems.addEventListener('click', (event) => { const button = event.target.closest('[data-remove-compare]'); if (!button) return; state.selected = state.selected.filter((value) => value !== button.dataset.removeCompare); renderCompare(); });
      compareOpen.addEventListener('click', () => {
        const table = root.querySelector('[data-compare-table]'); table.replaceChildren();
        const selectedRecords = state.selected.map((handle) => recordByHandle.get(handle)).filter(Boolean);
        const rows = [['Produkt', 'title'], ['System', 'series'], ['Solarmodule', 'module'], ['Modulzahl', '_modules'], ['Kapazität', '_capacity'], ['Status', 'available']];
        rows.forEach(([label, key]) => { const row = document.createElement('div'); row.className = 'mp-aio-compare-row'; const heading = document.createElement('strong'); heading.textContent = label; row.append(heading); selectedRecords.forEach((record) => { const cell = key === 'title' ? document.createElement('a') : document.createElement('span'); if (key === 'title') cell.href = record.dataset.url; cell.textContent = key === '_modules' ? labelList(record._modules, 'Module', 'Im Produkt') : key === '_capacity' ? labelList(record._capacity, 'kWh', 'Im Produkt') : key === 'available' ? (record.dataset.available === 'true' ? 'Verfügbar' : 'Ausverkauft') : record.dataset[key]; row.append(cell); }); table.append(row); });
        compareDialog.showModal();
      });
      const loadFullCatalog = () => {
        root._mpAioCatalogSchedule = null;
        if (!root.isConnected) return;
        applyAfterCatalog();
      };
      const scheduleFullCatalog = () => {
        if (catalogReady || root._mpAioCatalogSchedule) return;
        if (typeof window.requestIdleCallback === 'function') {
          root._mpAioCatalogSchedule = {
            type: 'idle',
            id: window.requestIdleCallback(loadFullCatalog, { timeout: 1200 })
          };
          return;
        }
        root._mpAioCatalogSchedule = { type: 'timeout', id: window.setTimeout(loadFullCatalog, 250) };
      };
      renderActive(); syncButtons(); apply(); scheduleFullCatalog();
    };
    const cleanup = (root) => {
      root._mpAioCatalogDisposed = true;
      const catalogSchedule = root._mpAioCatalogSchedule;
      if (catalogSchedule?.type === 'idle' && typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(catalogSchedule.id);
      if (catalogSchedule?.type === 'timeout') window.clearTimeout(catalogSchedule.id);
      root._mpAioCatalogAbort?.abort();
      root._mpTaxNoteObserver?.disconnect();
      if (root._mpHeroMedia && root._mpHeroSync) root._mpHeroMedia.removeEventListener('change', root._mpHeroSync);
      root._mpTaxNoteObserver = null;
      root._mpHeroMedia = null;
      root._mpHeroSync = null;
      root._mpAioCatalogSchedule = null;
      root._mpAioCatalogAbort = null;
    };
    document.querySelectorAll('[data-mp-aio]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-mp-aio]').forEach(init));
    document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-mp-aio]').forEach(cleanup));
  })();
